import { useState } from "react";
import axios from 'axios';
import { Container, CredentialWrapper, ContainerLogin, ContainerLogo, CreateAccount, ButtonEnter, Inputtype, ImgLogo, 
  Display, TitleInput, FormUser, ContainerInfoProd, Subtitle, SelectRadio, InfoProd } from "./style";
import LogoSVG from '../../Assets/images/logo.svg';
import { useToast } from "../../Hooks/useToast";
import { useAuth } from "../../Hooks/useAuth";
import { useLocation, useNavigate, Navigate} from "react-router-dom";
import LoadingFull from '../../Components/LoadingFull';
import InputFieldPassword from "./InputFieldPassword";
import InputFieldsetWithoutLegend from "../../Components/InputFieldsetWithoutLegend";

const LoginV2 = () => {
    const {addToast} = useToast();
    const {setToken, getToken} = useAuth();
    const location = useLocation();
    const navigate = useNavigate();

    const [disabledButton, setDisabledButton] = useState(false);
    const [cpf, setCpf] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState({show: false, message: ""});

    if(getToken()) {
        if(location.state?.from){
            const from = location.state?.from;
            return <Navigate to = {`${from.pathname}${from.search}`} />
        }

        return <Navigate to = {'/profile'} />
        
        
    }

    function handleKey(e) {
        if (e.key === "Enter") {
            checkAuthentication();
        }
    }

    

    const checkAuthentication = async () => {
        setDisabledButton(true);
        setIsLoading(true);
        setErrorMessage({...errorMessage, show: false});
        
        let apiUrl = process.env.REACT_APP_API_AUTH;
        const headers = {'Content-Type': 'application/json'}

        try{
            
            const response = await axios.post(apiUrl,{
                login: cpf,
                password: password
            }, headers);
            
            setToken(response.data);
            
        }catch(error){
            addToast("Error",  error.response.data.message, 0);
            setErrorMessage({show: true, message: error.response.data.message});
        }

        setIsLoading(false);
        setDisabledButton(false);
    }

    return (
        <>
        {isLoading ? (
          <LoadingFull height="100vh"/>
          ) : (
            <Container>
              <ContainerLogo>
                <ImgLogo src={LogoSVG} alt="Logo" />
              </ContainerLogo>
  
              <ContainerLogin>
                <CreateAccount>
                  <span>Novo usuário?</span>
                  <a target="_blank" href={process.env.REACT_APP_HOME_URL + "/#packages"}>
                    Criar conta agora!
                  </a>
                </CreateAccount>
  
                <Display>
                  <Inputtype>
                    <FormUser>Artistas</FormUser>
                    <TitleInput>CPF</TitleInput>
                    <InputFieldsetWithoutLegend type = 'text' value = {cpf} onChange = {(value) => {setCpf(value)}} />
  
                    <TitleInput>
                      <span>Senha</span>
                      <a target="_blank"  href={process.env.REACT_APP_RESET_PASSWORD_LINK}>Esqueci minha senha</a>
                    </TitleInput>
                    <InputFieldPassword 
                      value={password} 
                      onChange ={(value) => {setPassword(value)}} 
                      showPassword={showPassword} 
                      setShowPassword={setShowPassword}
                      handleKey={handleKey} 
                    />
  
                    <ButtonEnter>
                      <button disabled = {disabledButton} onClick={checkAuthentication}>Entrar</button>
                    </ButtonEnter>
                </Inputtype>
              </Display>
            </ContainerLogin>
          </Container>
          )}
        </>
      );
  
}

export default LoginV2;